function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscuela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(83,170,224)"
    },
    d: "M479.77-212.31 235.15-345.92v-193.85L123.08-600l356.69-193.85L836.92-600v253.92h-30.77v-235.84l-81.77 42.15v193.85L479.77-212.31Zm0-228.77L771.69-600 479.77-757.46 188.31-600l291.46 158.92Zm0 193.85 213.85-117v-156.46L479.77-406.3 265.92-521.92v157.69l213.85 117Zm.23-193.85Zm-.23 47.08Zm0 0Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscuela);
export default __webpack_public_path__ + "static/media/escuela.ef35a3e2a92528ea55a2930b38f205dc.svg";
export { ForwardRef as ReactComponent };